import {usePrimeCache} from "../../../Hooks/ServiceHooks";
import {service as SurveyTypeService} from "../../../Services/SurveyTypeService";
import {Form, Table} from "react-bootstrap";
import React, {Fragment} from "react";
import {Conditional} from "../../Conditional";
import {HelpIcon} from "../../Common/HelpIcon";
import * as PropTypes from "prop-types";

export const ConservationActionStatsTable = props => {

	usePrimeCache(SurveyTypeService);

	const getSurveyTypeHelper = (stat) => {
		const surveyType = SurveyTypeService.CachedValueByProperty(stat.code, 'code');
		if (!surveyType) {
			return null;
		}

		return <HelpIcon id={`help-icon-${stat.key}`}>This value is entered on the {surveyType.name} survey.</HelpIcon>
	};

	const renderRow = (x) => (<tr key={x.key} className={"sb-editor-row-ConservationActionStats_" + x.key}>
		<td className="sb-model-viewer-column sb-model-viewer-column-label">
			<Form.Label>
				{x.name}
				{getSurveyTypeHelper(x)}
			</Form.Label>
		</td>
		<td className="sb-model-viewer-column sb-model-viewer-column-value">
			<Conditional Condition={x.value != null}>
				<div>
					{x?.unitPrefix}{typeof x.value === 'number' ? Intl.NumberFormat().format(x.value) : x.value} {x?.unitSuffix}
				</div>
			</Conditional>
		</td>
	</tr>)

	return <Fragment>
		<h3 className="table-headers">Site Summary</h3>
		<Table className="sb-model-viewer table-bordered" striped size="sm">
			<tbody>
			{
				props.conservationActionStats.map(renderRow)
			}
			</tbody>
		</Table>
	</Fragment>;
};

ConservationActionStatsTable.propTypes = {
    conservationActionStats: PropTypes.arrayOf(PropTypes.any),
};
